import React from "react";
import NavbarContent from "../components/Navbar/navbar";
import ProjectContent from "../components/Projects/project";

export default function Project(){
       return(
              <>
              <NavbarContent/>
              <ProjectContent/>
              </>
       )
}